var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5045 0.383428C21.1263 0.801094 21.4996 1.50088 21.5 2.25V16.005C21.4473 18.1919 19.6869 19.9523 17.5 20.005C15.2909 20.005 13.5 18.2141 13.5 16.005C13.5 13.7959 15.2909 12.005 17.5 12.005H18.75C18.8881 12.005 19 11.8931 19 11.755V7.485C18.9999 7.40168 18.9583 7.32387 18.8891 7.27751C18.8199 7.23115 18.7321 7.22234 18.655 7.254L10.655 10.527C10.5609 10.565 10.4995 10.6565 10.5 10.758V20C10.4473 22.1869 8.68692 23.9473 6.5 24C4.29086 24 2.5 22.2091 2.5 20C2.5 17.7909 4.29086 16 6.5 16H7.75C7.88806 16 8 15.8881 8 15.75V5.932C7.99805 5.01732 8.55219 4.19326 9.39999 3.85L18.4 0.168C19.0936 -0.115002 19.8826 -0.0342376 20.5045 0.383428ZM10.611 7.726C10.6801 7.77249 10.7679 7.78149 10.845 7.75L18.845 4.474C18.9389 4.43573 19.0002 4.34437 19 4.243V3.367C19 3.20044 18.9171 3.0448 18.7789 2.9519C18.6406 2.859 18.4652 2.84104 18.311 2.904L10.811 5.973C10.6229 6.0498 10.5 6.23281 10.5 6.436V7.519C10.4997 7.6023 10.5415 7.68013 10.611 7.726Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote2);
export default __webpack_public_path__ + "static/media/musicNote2.603824a6.svg";
export { ForwardRef as ReactComponent };